export enum ContactModalPages {
  MainDetails = "Main Details",
  PropertyRequirements = "Property Requirements",
  Address = "Address",
  Marketing = "Marketing Preferences",
  SystemInfo = "System Info",
}
